// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"yj-z","trustedRetailerTooltipWrapper":"zj-z"};